import { z } from 'zod';

// `/runtime-config.js` sets window.runtimeConfig before the bundle loads. In a cluster the
// chart mounts that file from a ConfigMap, so the same image serves every environment.
const runtimeConfigSchema = z.object({
  API_BASE_URL: z.url().transform((url) => url.replace(/\/+$/, '')),
  /** Google Tag Manager container id. Unset = no analytics (local, blue). */
  GTM_ID: z
    .string()
    .regex(/^GTM-[A-Z0-9]+$/)
    .optional(),
});

export type RuntimeConfig = z.infer<typeof runtimeConfigSchema>;

let cached: RuntimeConfig | undefined;

export function runtimeConfig(): RuntimeConfig {
  if (cached) return cached;
  const parsed = runtimeConfigSchema.safeParse(window.runtimeConfig);
  if (!parsed.success) {
    throw new Error(
      `runtime-config.js is missing or invalid: ${z.prettifyError(parsed.error)}. ` +
        'It must define window.runtimeConfig.API_BASE_URL.',
    );
  }
  cached = parsed.data;
  return cached;
}

export function resetRuntimeConfigForTests(): void {
  cached = undefined;
}
